import { useTranslation } from 'next-i18next'
import { Text, Center, CenterProps } from '@chakra-ui/react'
import { FC } from 'react'

interface OptionHeaderProps extends CenterProps {
  option: string;
  value?: string;
}

const OptionHeader: FC<OptionHeaderProps> = ({ option, value, ...props }) => {
  return (
    <Center justifyContent="flex-start" mb={4} {...props}>
      <Text textStyle="productOption" mr={4}>
        {option}
      </Text>
      {value && (
        <Text fontWeight="light" fontSize={14}>
          {value}
        </Text>
      )}
    </Center>
  )
}

export default OptionHeader
